export const objectDefault = {
  invSerie: "",
  producto: "",
  numFactura: "",
  fechaFactura: "",
  codigo: "",
  descripcion: "",
  cantidad: "",
  valorUnitario: "",
  subtotal: "",
};

export const columns = [
  {
    id: "invSerie",
    label: "Serie",
    minWidth: 25,
    tipo: "string",
    propiedad: "invSerie",
  },
  {
    id: "producto",
    label: "Producto",
    minWidth: 25,
    tipo: "string",
    propiedad: "producto",
  },
  {
    id: "numFactura",
    label: "No. Factura",
    minWidth: 25,
    tipo: "string",
    propiedad: "numFactura",
  },
  {
    id: "fechaFactura",
    label: "Fecha Factura",
    minWidth: 25,
    tipo: "string",
    propiedad: "fechaFactura",
  },
  {
    id: "codigo",
    label: "Código",
    minWidth: 25,
    tipo: "string",
    propiedad: "codigo",
  },
  {
    id: "descripcion",
    label: "Descripción",
    minWidth: 25,
    tipo: "string",
    propiedad: "descripcion",
  },
  {
    id: "cantidad",
    label: "Cantidad",
    minWidth: 25,
    tipo: "string",
    propiedad: "cantidad",
  },
  {
    id: "valorUnitario",
    label: "Valor Unitario",
    minWidth: 25,
    tipo: "string",
    propiedad: "valorUnitario",
  },
  {
    id: "subtotal",
    label: "Subtotal",
    minWidth: 25,
    tipo: "string",
    propiedad: "subtotal",
  },
];
